import { useRef } from "react";
import useModal from "../hooks/useModal";
import Button from "./form-controls/Button";
import { useForm } from "react-hook-form";
import { useSession } from "../hooks/useSession";
import Input from "./form-controls/Input";
import Select from "./form-controls/Select";
import TextArea from "./form-controls/TextArea";
import { SupportService } from "../services/SupportService";
import { AlertService } from "../services/Alert";
import { DateUtil } from "../utils/date";

declare const flatpickr: any;

interface ModalSupportProps {
    show: boolean;
    onRequestClose: () => void;
}

function ModalSupport({ show, onRequestClose }: ModalSupportProps) {

    const { session } = useSession();

    const modalRef = useRef<HTMLDivElement>(null)
    const dateRef = useRef<HTMLDivElement>(null)

    useModal(modalRef, show)

    const defaultValues = {
        type_contact: 'WA',
        contact: '',
        reason: '',
        description: '',
        schedules: '',
    }
    const {  register, handleSubmit, watch, formState: { errors, isValid, isSubmitting, submitCount } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const type_contact = watch('type_contact')
    const reason = watch('reason')

    const submit = async (data) => {
        try {
            data.user_id = session.id
            await SupportService.openTicket(data)

            AlertService.success('!Éxito!', 'En breve un asesor se comunicará contigo')
        } catch (error) {
            AlertService.error('Error', 'Por el momento este servicio no esta disponible, intenta más tarde')
        }
    }


    const validateDate = (value) => {

        const date = DateUtil.moment(value)

        if(!date.isValid()) {
            return 'Formato de fecha incorrecto, utiliza DD-MM-YYYY HH:mm'
        }
        return true;
    }

    return (
        <div className="modal fade" ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
            <div className="modal-dialog " role="document">

                <div className="modal-content">
                    <div className="modal-header ">
                        <h4 className="modal-title" ><i className="bi-life-preserver me-2"></i> Hablar con un asesor</h4>
                        <button type="button" className="btn-close" onClick={onRequestClose} />
                    </div>
                    <div className="modal-body">

                        <p>Selecciona la forma de contacto que prefieras, ya sea correo electrónico o WhatsApp además de elegir el tipo de ayuda que necesitas.</p>
                        <p>De ser necesario puedes agendar una llamada con nuestros asesores.</p>

                        <div className="mb-3">
                            <Select
                                label={'Método de contacto *'}
                                data={ [{value: 'WA', text: 'WhatsApp' }, {value: 'email', text: 'Correo' }] }
                                errors={errors.type_contact}
                                {...register('type_contact', { required: true })}
                            />
                        </div>
                        <div className="mb-3">
                            <Input label={type_contact === 'WA' ?'Número de teléfono *': 'Correo *' } errors={errors.contact} {...register('contact', { required: true })} />
                        </div>
                        <hr />
                        <div className="mb-3">
                            <Select
                                label={'Motivo de tu solicitud de ayuda *'}
                                data={ [
                                    {value: 'incidencia', text: 'Incidencia' }, 
                                    {value: 'capacitación', text: 'Capacitación' },
                                    {value: 'requerimiento', text: 'Nuevo requerimiento' },
                                    {value: 'duda', text: 'Pregunta general' },
                                ] }
                                errors={errors.reason}
                                {...register('reason', { required: true })}
                            />
                        </div>

                        {
                            (reason === 'capacitación' || reason === 'requerimiento') && (
                                <>
                                    <div className="mb-3">
                                        <Input label='Fecha y hora de llamada (DD-MM-YYYY HH:mm)*' errors={errors.schedules} {...register('schedules', { required: true, validate: { custom: validateDate}  })} />
                                    </div>
                                </>
                            )
                        }

                        <hr />
                        <div className="mb-3">
                            <TextArea
                                label='Cuéntanos más acerca de tu duda o problema *'
                                errors={errors.description }
                                value={watch('description').length}
                                counter={1024}
                                {...register('description', { required: true, maxLength: { value: 1024, message: '1024' } })} />
                        </div>
                        

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-white btn-sm" onClick={onRequestClose} >Cerrar</button>
                        <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>Enviar</Button>
                    </div>
                </div>

            </div>
        </div>
    )
}
export default ModalSupport